import { apiService, createRequestHeadersConfig } from 'shared/api'

import {
  SaleOrderResponse,
  SaleOrderReturnRequestBody,
  SingleSaleOrderResponse} from './types'

const api = apiService()

interface GetSaleOrderDetailsPayload {
  token?: string
  id: string
}

export const fetchSaleOrderHistory = ({
  token,
  page,
  limit = 10
}: {
  token?: string
  page: number
  limit?: number
}): Promise<SaleOrderResponse> => {
  return api.get(`/sale-orders?page=${page}&limit=${limit}`, {
    ...createRequestHeadersConfig(token),
    cache: 'no-store'
  }) as Promise<SaleOrderResponse>
}

export const getSaleOrderDetails = (payload: GetSaleOrderDetailsPayload) => {
  const { id, token } = payload

  return api.get(
    `/sale-orders/${id}`,
    createRequestHeadersConfig(token)
  ) as Promise<SingleSaleOrderResponse>
}

export const cancelSaleOrder = (payload: GetSaleOrderDetailsPayload) => {
  const { id, token } = payload

  return api.patch(
    `/sale-orders/${id}/cancel`,
    {},
    createRequestHeadersConfig(token)
  )
}

interface SaleOrderReturnRequestPayload {
  id: string
  token?: string
  body: SaleOrderReturnRequestBody
}

export const returnSaleOrder = (
  returnOrderRequestPayload: SaleOrderReturnRequestPayload
) => {
  const { id, token, body } = returnOrderRequestPayload

  return api.post(
    `/sale-orders/${id}/return`,
    body,
    createRequestHeadersConfig(token)
  )
}
